// Parse existing query params
Shopify.queryParams = {};
if (location.search) {
  location.search
    .slice(1)
    .split("&")
    .forEach(function (p) {
      var [k, v] = p.split("=");
      Shopify.queryParams[decodeURIComponent(k)] = decodeURIComponent(v || "");
    });
}

// Sort change
document.querySelector("#sort-by").addEventListener("change", function (e) {
  Shopify.queryParams.sort_by = e.target.value;
  location.search = new URLSearchParams(Shopify.queryParams).toString();
});

// Collection change
document
  .querySelector("#collection-filter")
  .addEventListener("change", function (e) {
    var collection = e.target.value;
    console.log("collection:", collection);
    var qs = Shopify.queryParams.sort_by
      ? "?sort_by=" + Shopify.queryParams.sort_by
      : "";
    location.href = "/collections/" + collection + qs;
  });
